export const VIDEO_PLAYER_PLAYBACK_ACTIONS = {
  VIDEO_PLAYBACK_STARTED: 'VIDEO_PLAYER_PLAYBACK.VIDEO_PLAYBACK_STARTED',
  VIDEO_PLAYBACK_STOPPED: 'VIDEO_PLAYBACK_STOPPED.VIDEO_PLAYBACK_STOPPED',
};

export const videoPlayerPlaybackStarted = () => ({
  type: VIDEO_PLAYER_PLAYBACK_ACTIONS.VIDEO_PLAYBACK_STARTED,
  payload: undefined,
});

export const videoPlayerPlaybackStopped = () => ({
  type: VIDEO_PLAYER_PLAYBACK_ACTIONS.VIDEO_PLAYBACK_STOPPED,
  payload: undefined,
});
